@if (!referralMode && !cancellationMode) {
<app-dialog-header titleTranslateKey="scheduler.booking.confirm.title" (closeClicked)="onCancelClick()">
</app-dialog-header>
}
@if (referralMode) {
<app-dialog-header titleTranslateKey="scheduler.booking.refer.title" (closeClicked)="onCancelClick()">
</app-dialog-header>
}
@if (cancellationMode) {
<app-dialog-header titleTranslateKey="scheduler.booking.cancel.title" (closeClicked)="onCancelClick()">
</app-dialog-header>
}
<mat-dialog-content>
  @if (!referralMode && !cancellationMode && !floatingMode) {
  @if (!availabilityInfo?.feasible) {
  <div class="booking-warning">
    {{ 'scheduler.booking.resource.insufficient' | translate }}
    <br />
    @if (permitForceBooking && !ticketDurationTooLong) {
    <mat-checkbox (change)="changeForceFlag($event)" [(ngModel)]="forceBooking">Force Booking</mat-checkbox>
    }
    @if (!permitForceBooking && !ticketDurationTooLong) {
    <p>This booking is not able to be force booked at the present time. Please refresh slots and try again. </p>
    }
    @if (!permitForceBooking && ticketDurationTooLong) {
    <p>This booking is not able to be force booked, ticket duration is too long. </p>
    }
  </div>
  }
  <p>
    @if (availabilityInfo && !floatingMode) {
    <strong>
      {{ schedulerBookingMessage }}
      {{ availabilityInfo.startTime | amLocal | amDateFormat : 'h:mm A' }}
      and {{ availabilityInfo.endTime | amLocal | amDateFormat : 'h:mm A' }}
    </strong>
    }
    @if (availabilityInfo && floatingMode) {
    <strong>
      {{ schedulerFloatingMessage }}
    </strong>
    }
  </p>
  }
  @if (referralMode) {
  <p>
    <strong>
      {{ schedulerReferralMessage }}
    </strong>
  </p>
  }
  <form [formGroup]="noteForm">
    <mat-form-field style="width:100%">
      <mat-select (selectionChange)="reasonChanged($event)" [compareWith]="compareObjects"
        formControlName="bookingReason" placeholder="Select Booking Reason">
        @for (bookingReason of validReasons; track bookingReason) {
        <mat-option [value]="bookingReason">{{ bookingReason.description }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (notesVisible) {
    <mat-form-field style="width:100%">
      <textarea formControlName="notes" matInput placeholder="Notes" style="width:100%"></textarea>
    </mat-form-field>
    }
  </form>

  <p>{{ 'scheduler.booking.confirm.message' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onSelectClick()" [disabled]="!noteForm.valid" cdkFocusInitial color="primary" mat-raised-button>
    {{ 'scheduler.general.confirm' | translate }}
  </button>
</mat-dialog-actions>